import {
  SupplyShedAggregationType,
  SupplyShedCashCropChoice,
  SupplyShedCoverCropChoice,
  SupplyShedTillageChoice,
} from '@cibo/core'
import { PropsWithChildren, useState } from 'react'
import { SupplyShedFiltersContext } from './SupplyShedFiltersContext'

const DEFAULT_YEAR = new Date().getFullYear() - 1

export const SupplyShedProvider = ({ children }: PropsWithChildren<object>) => {
  const [aggregationType, setAggregationType] = useState<SupplyShedAggregationType>('state')
  const [cashCrops, setCashCrops] = useState<SupplyShedCashCropChoice[]>([])
  const [tillageTypes, setTillageTypes] = useState<SupplyShedTillageChoice[]>([])
  const [coverCrop, setCoverCrop] = useState<SupplyShedCoverCropChoice>()
  const [year, setYear] = useState(DEFAULT_YEAR)

  return (
    <SupplyShedFiltersContext.Provider
      value={{
        aggregationType,
        setAggregationType,
        coverCrop,
        setCoverCrop,
        cashCrops,
        setCashCrops,
        tillageTypes,
        setTillageTypes,
        year,
        setYear,
      }}
    >
      {children}
    </SupplyShedFiltersContext.Provider>
  )
}
